import { useWorkbookAccessSettings } from "@/payroll/workbook-access/query";
import { useUserManagementAccess } from "@/user/management-access";

export const useUsersWorkbookAccess = (businessId?: string | null) => {
  const { canManageWorkbookAccess } = useUserManagementAccess(businessId);
  const query = useWorkbookAccessSettings(
    canManageWorkbookAccess ? (businessId ?? null) : null,
  );
  const settings =
    !query.isError && query.data?.access_keys.length ? query.data : undefined;
  return { query, settings };
};
